<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-justify">
          Estimado solicitante, con fecha {{ fecha }}, usted acaba de enviar una solicitud de
          reclamo.
        </p>
        <p class="text-justify">
          La solicitud deberá ser, previamente, revisada y validada por Servel. Para luego, ser notificado al correo electrónico
          informado del resultado final de la solicitud.
        </p>
      </div>
    </div>
    <el-divider></el-divider>

    <template v-if="media.sm">
      <div class="row text-center">
        <div class="col">
          <el-button type="success" @click="endProcess" class="terminar" data-cy="affiliation-end">
            Terminar
          </el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-content-end">
        <el-button type="success" @click="endProcess" class="terminar" data-cy="affiliation-end">
          Terminar
        </el-button>
      </div>
    </template>
  </div>
</template>

<script>
import {Divider} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import moment from "moment";

export default {
  name: "ReclamoExitoso",
  components: {
    [Divider.name]: Divider,
  },
  mixins: [
    ScreenSizeMixin,
    RouterMixin
  ],
  computed: {
    fecha: function () {
      return moment().format("DD-MM-YYYY")
    }
  },
  methods: {
    endProcess() {
      this.navigate({name: 'resumen-tramites'})
    }
  }
}
</script>
